import React, { useState } from 'react';
import { useFormikContext } from 'formik';

const StarScalePreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;
  const [hoverIndex, setHoverIndex] = useState(null);

  const choices = (question.questionChoicesAttributes || [])
    .filter(c => !c._destroy)
    .sort((a, b) => a.position - b.position);

  const currentValue = values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(
    eqc => eqc?.questionId === question.id
  )?.questionChoiceId;

  const selectedIndex = choices.findIndex(c => String(c.id || c.position) === String(currentValue));

  const handleSelect = choice => {
    if (disabled) return;
    setFieldValue(`${fieldName}[questionChoiceId]`, choice.id || choice.position);
  };

  return (
    <div className="eval-star-preview-row">
      {choices.map((choice, idx) => {
        const effectiveIndex = hoverIndex !== null ? hoverIndex : selectedIndex;
        const filled = effectiveIndex >= 0 && idx <= effectiveIndex;
        const className = ['eval-star-preview-item', filled ? 'filled' : '', disabled ? 'disabled' : '']
          .filter(Boolean)
          .join(' ');

        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <span
            key={choice.id || choice.position}
            className={className}
            onClick={() => handleSelect(choice)}
            onMouseEnter={() => !disabled && setHoverIndex(idx)}
            onMouseLeave={() => !disabled && setHoverIndex(null)}
          >
            ★
          </span>
        );
      })}
    </div>
  );
};

export default StarScalePreview;
